<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">お問い合わせ</h2>
                    </div>
                </div>
            </div>
        </section>
        <section id="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div><h2>ご相談・お問い合わせ</h2>この度は弊社ホームページをご覧頂きまして誠にありがとうございます。こちらでは弊社へのご相談やお問い合わせ、ご質問などを承っております。</div>
                        <br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <form name="sentMessage" id="contactForm" novalidate>
                            <h5>　※貴社のご希望や課題に対してスムーズに対応するため、下記項目のご入力をお願いいたします。担当よりご連絡をさせていただきます。</h5>
                            <div class="control-group">
                                <div class="controls">
                    お名前<input type="text" class="form-control" 
                                    placeholder="例) 山田　太郎" id="name" required
                                    data-validation-required-message="Please enter your name" />
                                    カタカナ<input type="text" class="form-control" 
                                    placeholder="例) ヤマダ　タロウ" id="name" required
                                    data-validation-required-message="Please enter your name" />
                                    <p class="help-block"></p>
                                </div>
                            </div> 	
                            <div class="control-group">
                                <div class="controls">
                                    電話番号<input type="email" class="form-control" placeholder="例) 08012345678" 
                                        id="email" required
                                    data-validation-required-message="Please enter your tel" />
                                    メールアドレス<input type="email" class="form-control" placeholder="例) email@domain.com" 
                                        id="email" required
                                    data-validation-required-message="Please enter your email" />
                                </div>
                            </div> 	
                            <div class="control-group">
                                <div class="controls">
                                    <textarea rows="10" cols="100" class="form-control" 
                                        placeholder="" id="message" required
                                        data-validation-required-message="Please enter your message" minlength="5" 
                                        data-validation-minlength-message="Min 5 characters" 
                                        maxlength="999" style="resize:none"></textarea>
                                </div>
                            </div> 		 
                            <div id="success"> </div> <!-- For success/fail messages -->
                            <button type="submit" class="btn btn-primary pull-right">送信</button><br/>
                        </form>	
                    </div>
                    <div class="col-md-offset-1 col-md-6">
                    <!--<script type="text/javascript" src="http://maps.google.com/maps/api/js?sensor=false"></script><div style="overflow:hidden;height:500px;width:600px;"><div id="gmap_canvas" style="height:500px;width:600px;"></div><style>#gmap_canvas img{max-width:none!important;background:none!important}</style><a class="google-map-code" href="http://www.trivoo.net" id="get-map-data">trivoo</a></div><script type="text/javascript"> function init_map(){var myOptions = {zoom:14,center:new google.maps.LatLng(35.3792203,139.5932697),mapTypeId: google.maps.MapTypeId.ROADMAP};map = new google.maps.Map(document.getElementById("gmap_canvas"), myOptions);marker = new google.maps.Marker({map: map,position: new google.maps.LatLng(35.3792203,139.5932697)});infowindow = new google.maps.InfoWindow({content:"<b>The Breslin</b><br/>2880 Broadway<br/> New York" });google.maps.event.addListener(marker, "click", function(){infowindow.open(map,marker);});infowindow.open(map,marker);}google.maps.event.addDomListener(window, 'load', init_map);</script>-->
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3248.037353537548!2d139.6915903151063!3d35.50335458023619!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60186756f863076d%3A0x3fea1bb032d82975!2z44Kv44Ot44K344Kn44OD44OI!5e0!3m2!1sja!2sjp!4v1639976455019!5m2!1sja!2sjp" width="600" height="500" frameborder="0" style="border:0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </section>
        <a href="#" class="scrollup"><i class="fa fa-angle-up active"></i></a>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>